// import React, { Component, Fragment } from "react";
// import queryString from "query-string";
// import Sidebar from "react-sidebar";
// import Settings from "./settings";
// import SideMenu from "./sideMenu";
// import "../../assets/scss/pages/app-library.scss";
// import "../../assets/scss/pages/profile.scss";
// import "../../assets/scss/pages/common.scss";

// const mql = window.matchMedia(`(min-width: 992px)`)
// import { inject, observer } from 'mobx-react';

// class ProfileApp extends Component {
//   state = {
//     sidebarDocked: mql.matches,
//     sidebarOpen: false,
//     page_name: "general"
//   }
//   UNSAFE_componentWillMount() {
//     mql.addListener(this.mediaQueryChanged)
//   }

//   componentWillUnmount() {
//     mql.removeListener(this.mediaQueryChanged)
//   }

//   onSetSidebarOpen = open => {
//     this.setState({ sidebarOpen: open })
//   }

//   mediaQueryChanged = () => {
//     this.setState({ sidebarDocked: mql.matches, sidebarOpen: false })
//   }
//   render() {
//     return (
//       <React.Fragment>
//         <div className="_library-application">
//           <div
//             className={`library-content-overlay ${
//               this.state.sidebarOpen ? "show" : ""
//               }`}
//             onClick={() => this.onSetSidebarOpen(false)}></div>
//           <div className="sidebar-section">
//             <Sidebar
//               sidebar={
//                 <SideMenu 
//                   selectPage={(page_name) => { this.setState({ page_name }) }} 
//                   currentPage={this.state.page_name}
//                   />
//               }
//               docked={this.state.sidebarDocked}
//               open={this.state.sidebarOpen}
//               sidebarClassName="sidebar-library"
//               touch={true}
              
//               contentClassName="sidebar-children d-none">
//               ""
//             </Sidebar>
//           </div>
//           <Settings
//             mainSidebar={this.onSetSidebarOpen}
//             sidebar={this.state.sidebarOpen}
//             renderPage={this.state.page_name}
//           />
//         </div>
//       </React.Fragment>
//     )
//   }
// }


// export default ProfileApp;


import React from "react"
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardBody
} from "reactstrap"
import classnames from "classnames";
import { Instagram, Unlock, Settings } from "react-feather";
import General from "./pages/general";
import ChangePassword from "./pages/changePassword";
import SocialLinks from "./pages/socialLinks";

import "../../assets/scss/pages/account-settings.scss"
import "../../assets/scss/pages/settings.scss";
import "../../assets/scss/pages/common.scss";
import "../../assets/scss/pages/account-settings.scss"

class ProfileApp extends React.Component {
  state = {
    activeTab: "1",
    windowWidth: null
  }

  toggle = tab => {
    this.setState({
      activeTab: tab
    })
  }

  updateWidth = () => {
    this.setState({ windowWidth: window.innerWidth })
  }

  componentDidMount() {
    if (window !== undefined) {
      this.updateWidth()
      window.addEventListener("resize", this.updateWidth)
    }
  }


  render() {
    let { windowWidth } = this.state
    return (
      <React.Fragment>

        <div className={`${windowWidth >= 769 ? "nav-vertical" : "account-setting-wrapper"}`}>
          <Nav className="account-settings-tab nav-left mr-0 mr-sm-3" tabs>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "1"
                })}
                onClick={() => {
                  this.toggle("1")
                }}
              >
                <Settings size={16} />
                <span className="d-md-inline-block d-none align-middle ml-1">General</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "2"
                })}
                onClick={() => {
                  this.toggle("2")
                }}
              >
                <Unlock size={18} />
                <span className="d-md-inline-block d-none align-middle ml-1">Change Password</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "3"
                })}
                onClick={() => {
                  this.toggle("3")
                }}
              >
                <Instagram size={18} />
                <span className="d-md-inline-block d-none align-middle ml-1">Social Links</span>
              </NavLink>
            </NavItem>
          </Nav>
          <Card>
            <CardBody>
              <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                  <General />
                </TabPane>
                <TabPane tabId="2">
                  <ChangePassword />
                </TabPane>
                <TabPane tabId="3">
                  <SocialLinks />
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </div>
      </React.Fragment>
    )
  }
}

export default ProfileApp;
